import { render, staticRenderFns } from "./ProjectDescriptionPage.vue?vue&type=template&id=f342e900&lang=pug&"
import script from "./ProjectDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./ProjectDescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDescriptionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports